module.exports = __webpack_public_path__ + "static/media/anzuum (4).fa04d059.png";